import { useCallback, useState } from 'react'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { insertVideo } from 'core-components/library/richTextEditor/helpers/slateHelper'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { TVideo } from 'core-components/library/richTextEditor/interface/TVideo'
import { VideoSettingsDialog } from 'core-components/library/richTextEditor/toolbar/components/video/VideoSettingsDialog'

import { TOOLBAR_TITLES } from '../../constants'

interface IProps {
  disabled: boolean
  className?: string
}

export const VideoButton = ({ disabled, className }: IProps) => {
  const [videoSettingsModalVisible, setVideoSettingsModalVisible] = useState(false)

  const editor = useSlate()

  const addVideo = (settings: TVideo) => {
    insertVideo(editor, settings)
    onClose()
  }

  const onClose = useCallback(() => {
    setVideoSettingsModalVisible(false)
  }, [])

  return (
    <>
      <Button
        className={className}
        onClick={() => {
          setVideoSettingsModalVisible(true)
        }}
        title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.Video]}
        disabled={disabled}
        color={'grey'}
        variant={'text'}
        iconButton={'kbase kbase-video'}
      />
      <ModalDialog
        title={'Upload video'}
        content={VideoSettingsDialog}
        contentProps={{
          videoSettings: {},
          onSave: (settings: TVideo) => {
            addVideo(settings)
          },
          onCancel: () => onClose(),
        }}
        size={'auto'}
        onClose={onClose}
        show={videoSettingsModalVisible}
      />
    </>
  )
}
